import type {
	RemoteConfigNumberKey,
	RemoteConfigStringKey,
} from '../interfaces';

/**
 * In-process Remote Config fallbacks used against the local emulator suite,
 * where there is no live template to fetch. Values match `config/dev-firebase.config.json`.
 */
export const RemoteConfigNumberDefaults: Record<RemoteConfigNumberKey, number> =
	{
		max_plot_count: 5000,
		max_row_count: 1_000_000,
		max_purge_count: 1,
		analysis_expiration_extension_threshold_days: 7,
		analysis_expiration_extension_days: 30,
	};

export const RemoteConfigStringDefaults: Record<RemoteConfigStringKey, string> =
	{
		legacy_tool_url: 'https://legacyquad.marmon.com',
		feedback_form_url:
			'https://forms.office.com/Pages/ResponsePage.aspx?id=XUTHK-iQVkq37Jh-mpFRH9gJyiBgVNBFuTshzKrTPGtUNU9KVjlQODc1RTNENE84SUMyM1hVRUcwQi4u',
		faq_url:
			'https://at.marmon.com/departments/continuous_improvement/business_acumen/8020quadtool',
		quick_start_guide_url:
			'https://at.marmon.com/departments/continuous_improvement/business_acumen/8020quadtool',
		krista_prompt_version: '2026.08.1',
		krista_kb_version: '2026.08.1',
		krista_methodology_source: 'vizashift_methodology_thresholds_v1',
	};

/** String map suitable for `remoteConfig.defaultConfig`. */
export const RemoteConfigDefaultConfig: Record<string, string> =
	Object.fromEntries(
		[
			...Object.entries(RemoteConfigNumberDefaults),
			...Object.entries(RemoteConfigStringDefaults),
		].map(([key, value]) => [key, String(value)]),
	);
